import {
  MENU_FOLD_OUT,
  MENU_UNFOLD_OUT,
  PAGINATION_SAVE,
  SIDER_BREAKPOINT_FOLD,
  SIDER_BREAKPOINT_UNFOLD
} from '../app/constant'

export const menuFoldOut = () => {
  return {
    type: MENU_FOLD_OUT
  }
}

export const menuUnfoldOut = () => {
  return {
    type: MENU_UNFOLD_OUT
  }
}

export const breakpointFold = () => {
  return {
    type: SIDER_BREAKPOINT_FOLD
  }
}

export const breakpointUnfold = () => {
  return {
    type: SIDER_BREAKPOINT_UNFOLD
  }
}

export const onPaginationSave = (info) => {
  return {
    type: PAGINATION_SAVE,
    info: info
  }
}
